import React, {Component} from 'react'
import './HyperLinkContainer.css'
import {server_ip} from '../../../ipAddress'
import PageSelectFunctionArea from './PageSelectFunctionArea'
import Table from '@material-ui/core/Table'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import MovieRecordContainer from '../../Routes/Record/MovieRecordContainer'

const wStyles = theme => ({
    HyperLinkContainerTable: {
       height:"400px"
    },
})

class HyperLinkContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listData:null,
            searchWord:null,
            limitNumber:10,
            pageNumber:1,
            totalNumber:null,
            selectedRowInfo:null,
            selectedRecordSysID:null,
            showRecordcontain:null,
        }
    }

    componentDidMount(){
        console.log("HyperLinkContainer componentDidMount...")
        this.initialState()
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.limitNumber !== this.state.limitNumber || prevState.pageNumber !== this.state.pageNumber)
        {
            this.initialState()
        }
    }

    componentWillUnmount(){
       
    }

    initialState=()=>{
        let obj = {
            boolean:"AND",
            columnName:"Movie_TitleMain",
            keyword:this.props.keyword,
            operator:"Like"
        }
        let tempArray = [obj]

        this.setState({
            searchWord:tempArray
        },()=>{
            this.refreshList()
        })
    }

    refreshList=()=>{
        this.getRecordByAdvanceSearch()
        .then(res=>{
            if(res[0])
            {
                this.setState({
                    listData:res,
                    totalNumber:res[0].Movie_TotalCount
                })
            }
            else
            {
                this.setState({
                    listData:null,
                    totalNumber:0
                })
            }
        })
    }

    getRecordByAdvanceSearch = async()=>{
        console.log("proceed getRecordByAdvanceSearch...")
        let limitNumber = this.state.limitNumber
        let pageNumber = this.state.pageNumber
        let orderType = "ASC"
        let orderColumn = "Movie_TitleMain"
        let queryWords = encodeURI(JSON.stringify(this.state.searchWord))
        console.log("limitNumber : ",limitNumber)
        console.log("pageNumber : ",pageNumber)
        console.log("orderType : ",orderType)
        console.log("orderColumn : ",orderColumn)
        console.log("queryWords : ",queryWords)
        let msg = await fetch(server_ip+'/api/movie/advanceQuery/frontend/limit/'+limitNumber+'/pageNumber/'+pageNumber+'/orderColumn/'+orderColumn+'/orderType/'+orderType+'/query/'+queryWords)

        let output = await msg.json()
        if(msg.status !== 200) throw Error(msg.message)
        
        return output
    }

    createListBody=()=>{
        if(this.state.listData && this.state.listData.length > 0)
        {
            return (
                <TableBody>{this.createListRow()}</TableBody>
            )
        }
        else
        {
            return "查無資料"
        }

    }

    createListHead=()=>{
        if(this.state.listData && this.state.listData.length > 0)
        {
            return(
                <TableHead className={"HyperLinkContainerTableHead"}>
                    <TableRow>
                        <TableCell className={"RowHeadTitle"} >序號</TableCell>
                        <TableCell className={"RowHeadTitle"} >片名</TableCell>
                        <TableCell className={"RowHeadTitle"} >出品日期</TableCell>
                        <TableCell className={"RowHeadTitle"} >出品人</TableCell>
                        <TableCell className={"RowHeadTitle"} >選取</TableCell>
                    </TableRow>
                </TableHead>
            )
        }
        else
        {
            return null
        }
    }

    createListRow=()=>{
        if(this.state.listData && this.state.listData.length > 0)
        {
            
            let output = this.state.listData.map((row,index)=>{
                return(
                    <TableRow hover key={index} onClick={()=>this.openMovieDetailInfo(row.Movie_SysID)}>
                        <TableCell className={"RowHeadTitle"} align="left">{index+1}</TableCell>
                        <TableCell className={"RowHeadTitle"} align="left">{row.Movie_TitleMain}</TableCell>
                        <TableCell className={"RowHeadTitle"} align="left">{row.Movie_ProductionDate}</TableCell>
                        <TableCell className={"RowHeadTitle"} align="left">{row.Movie_Producer}</TableCell>
                        <TableCell className={"RowHeadTitle"} align="left"><button onClick={(e)=>this.selectHyperLinkAddress(e,row.Movie_SysID)}>選取</button></TableCell>
                    </TableRow>
                )
            })

            return output
        }
        else
        {
            return <div className={"HyperLinkContainerInfo"}>無相關電影作品</div>
        }
        
    }

    getPageLimitInfo=(number)=>{
        if(this.state.limitNumber !== number)
        {
            this.setState({
                limitNumber:number
            })
        }
    }

    getPageNumberInfo=(number)=>{
        if(this.state.pageNumber !== number)
        {
            this.setState({
                pageNumber:number
            })
        }
    }

    openMovieDetailInfo=(sysID)=>{
        console.log("openMovieDetailInfo")
        console.log(sysID)
        this.setState({selectedRecordSysID:sysID, showRecordcontain:true})
    }

    selectHyperLinkAddress=(e,sysID)=>{
        e.stopPropagation()
        console.log("selectHyperLinkAddress")
        console.log(sysID)
        //let address = frontWebServer_ip+'/Movie/Workinfo/'+sysID
        let address = '/Movie/Workinfo/'+sysID
        this.props.getHyperLink(address)
    }

    cancel=()=>{
        this.props.toggleHyperLinkContainer()
    }


    render(){
        const {classes} = this.props;
       
        return(
            <div className={"HyperLinkContainerMask"}>
                {this.state.showRecordcontain? <MovieRecordContainer movieSysID={this.state.selectedRecordSysID} keywords={null} closeModal={()=>this.setState({selectedRecordSysID:null,showRecordcontain:false})}/>:null}
                <div className={"HyperLinkContainer"}>
                    <PageSelectFunctionArea getPageLimitInfo={this.getPageLimitInfo} getPageNumberInfo={this.getPageNumberInfo} storedLimitNumber={this.state.limitNumber} storedPageNumber={this.state.pageNumber} storedTotalNumber={this.state.totalNumber}/>   
                    <TableContainer className={classes.HyperLinkContainerTable}>
                        <Table aria-label="customized table" stickyHeader>
                            {this.createListHead()}
                            {this.createListRow()}               
                        </Table>       
                    </TableContainer>
                    <div style={{height:"50px"}}><div className={"HyperLinkContainerCancelButtom"} onClick={this.cancel}>取消</div></div>
                </div>                
            </div>
        )
    }
}

export default withStyles(wStyles)(HyperLinkContainer)